// ----------------------------
// REGULATOR ENVIRONMENT
// ----------------------------

/** Whether the app is running on the regulator origin (regulatory body audit surface). */
export function isRegulatorEnvironment(): boolean {
  return window.location.origin.includes('-regulator');
}

// ----------------------------
// INTERNAL (NOENV) ENVIRONMENT
// ----------------------------

/** Whether the app is running on an internal noenv.eu origin where third-party scripts are disabled. */
export function isNoenvOrigin(): boolean {
  return window.location.origin.includes('noenv.eu');
}

// ----------------------------
// NATIVE APP INFO
// ----------------------------

export interface NativeAppInfo {
  nativeAppOs: 'ios' | 'android' | string;
  nativeAppOsVersion: string;
  nativeAppName: string;
  nativeAppVersion: string;
  nativeAppBundleId: string;
}

export function getNativeAppInfo(): NativeAppInfo | null {
  // User-Agent: Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CustomContent:iOS/17.0.1/TipicoGamesUE/1.0/tipico.games.eu
  const userAgent = window.navigator.userAgent;
  const split = userAgent.split('CustomContent:');
  if (split.length === 2) {
    const customContent = split[1]!;
    const tokens = customContent.split('/');
    if (tokens.length === 5) {
      return {
        nativeAppOs: tokens[0]!.toLowerCase(),
        nativeAppOsVersion: tokens[1]!,
        nativeAppName: tokens[2]!,
        nativeAppVersion: tokens[3]!,
        nativeAppBundleId: tokens[4]!,
      };
    }
  }

  return null;
}

// ----------------------------
// TOUCHSCREEN
// ----------------------------

export function isTouchscreen() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

// ----------------------------

export function logEnvironment() {
  const obj = {} as any;
  obj.userAgent = navigator.userAgent;
  obj.isNativeApp = window.$app.device.isNativeApp;
  obj.isIos = window.$app.device.isIos;
  obj.isAndroid = window.$app.device.isAndroid;
  obj.isMobileDevice = window.$app.device.isMobileDevice;
  obj.isMWeb = window.$app.device.isMWeb;
  obj.isMWebIos = window.$app.device.isMWebIos;
  obj.isMWebAndroid = window.$app.device.isMWebAndroid;
  window.$app.logger.log('Environment:', obj);
}

// isDesktopView() removed.
// Better solution:
// Solution for HTML: <Breakpoint min/max={BreakpointKey.large}>
// Solution for CSS: ${({ theme }) => theme.media.up/down(BreakpointKey.large)`
// Solution for Code: const isDesktop = useBreakpoint(BreakpointKey.large);
